module.exports = __webpack_public_path__ + "img/1.715f9825.png";